/** @format */

import React from 'react';

import { useCarouselDots } from './useCarouselDots';

type CarouselDotsProps = {
  total: number;
  current: number;
  visible: number;
};

export const CarouselDots: React.FC<CarouselDotsProps> = ({ total, current, visible }) => {
  const {
    defaultHolderStyle,
    getHolderStyle,
    dots,
    defaultDotsStyle,
    getDotsStyle,
    defaultDotStyle,
    getDotStyle,
    defaultVisibleDotStyle,
    defaultActiveDotStyle,
    isActive,
    isVisible,
  } = useCarouselDots({
    total,
    current,
    visible,
  });

  return (
    <div style={{ ...defaultHolderStyle, ...getHolderStyle }}>
      {dots.map((dot: number) => {
        return (
          <div key={dot} style={{ ...defaultDotsStyle, ...getDotsStyle }}>
            <div
              key={`${dot}-inner`}
              style={{
                ...defaultDotStyle,
                ...getDotStyle,
                ...(isActive(dot) ? defaultActiveDotStyle : {}),
                ...(isVisible(dot) ? defaultVisibleDotStyle : {}),
              }}
            />
          </div>
        );
      })}
    </div>
  );
};
